import { useMemo } from "react";
import { useGetFormQuery, useGetFormsQuery } from "./formEndpoints";
import { Form } from "src/entities/form";

/**
 * @param formID
 * @param opt
 * @param opt.skip
 */
export function useForm(
  formID: number | undefined | null,
  opt?: { skip?: boolean }
) {
  const formQuery = useGetFormQuery(formID ?? 0, {
    skip: !formID || opt?.skip,
  });
  const formEntity = formQuery.data;

  return useMemo(() => {
    const ret: typeof formQuery & {
      form?: Form | undefined;
    } = {
      ...formQuery,
    };
    if (formEntity) ret.form = new Form(formEntity);
    return ret;
  }, [formQuery, formEntity]);
}

/**
 *
 */
export function useForms() {
  const formQuery = useGetFormsQuery();
  const formEntitiesMap = formQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof formQuery & {
      forms?: Form[];
      formsMap?: { [id: number]: Form };
    } = {
      ...formQuery,
      forms: [],
      formsMap: {},
    };
    if (formEntitiesMap) {
      const forms: Form[] = [];
      const formsMap: { [id: number]: Form } = {};

      for (const key in formEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(formEntitiesMap, key)) {
          const c = formEntitiesMap[key];
          const form = new Form(c);
          forms.push(form);
          formsMap[form.id] = form;
        }
      }
      ret.forms = forms;
      ret.formsMap = formsMap;
    }

    return ret;
  }, [formQuery, formEntitiesMap]);
}
